<div class="card" >
  <app-header titulo="Cadastro de Nota" descricao="Digite as informações da Nota"></app-header>

  <div class="formgrid grid p-fluid">
        <div class="field col-4">
          <label for="empresaErp">Empresa ERP: </label>
          <p-dropdown
             appendTo="body"
             [options]="empresas"
             [filter]="true"
             optionValue="empresaErp"
             optionLabel="empresaErp"
             [(ngModel)]="nota.empresaErp"
             dataKey="id" inputId="id"
             placeholder="Código Empresa ERP"
              emptyMessage="Nenhuma código"
              >
            </p-dropdown>
        </div>
        <div class="field col-4">
          <label for="ordem">Ordem: </label>
          <input
            type="text"
            id="ordem"
            maxlength="20"
            pInputText
            [(ngModel)]="nota.ordem"
            required
          />
        </div>
        <div class="field col-4">
          <label for="tipoPropriedade">Tipo Propriedade: </label>
          <input
            type="text"
            id="tipoPropriedade"
            maxlength="2"
            pInputText
            [(ngModel)]="nota.tipoPropriedade"
            required
          />
        </div>
        <div class="field col-4">
          <label for="contaContabil">Conta Contabil: </label>
          <input
            type="text"
            id="contaContabil"
            maxlength="20"
            pInputText
            [(ngModel)]="nota.contaContabil"
            required
          />
        </div>
        <div class="field col-4">
          <label for="centroCusto">Centro de custo: </label>
          <input
            type="text"
            id="centroCusto"
            maxlength="20"
            pInputText
            [(ngModel)]="nota.centroCusto"
            required
          />
        </div>
        <div class="field col-4">
          <label for="materialErp">Material ERP: </label>
          <input
            type="text"
            id="materialErp"
            maxlength="20"
            pInputText
            [(ngModel)]="nota.materialErp"
            required
          />
        </div>
        <div class="field col-4">
          <label for="cdProcesso">Processo: </label>
          <p-dropdown
             appendTo="body"
             [options]="processos"
             [filter]="true"
             optionValue="id"
             optionLabel="nome"
             [(ngModel)]="nota.cdProcesso"
             dataKey="id" inputId="id"
             placeholder="Código Processo"
              emptyMessage="Nenhuma código"
              >
            </p-dropdown>
        </div>
        <div class="field col-2 pt-4">
          <button
            pButton
            icon="pi pi-save"
            class="p-button-success"
            [label]="nota.id ? 'Atualizar' : 'Salvar'"
            (click)="salvar()"
          ></button>
        </div>
        <div class="field col-2 pt-4">
          <button
           pButton label="Cancelar"
           icon="pi pi-times"
           class="p-button-text"
           (click)="fecharDialog()"></button>
        </div>
  </div>
</div>
